// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2A64E","label":"Section_label__2mDRm","contentWrap":"Section_contentWrap__QOzqA","footer":"Section_footer__1KcW6","footerInner":"Section_footerInner__3FoBP"};